"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SchedulerTools = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const labels_1 = __importDefault(require("@/app/shared/i18n/labels"));
const outline_1 = require("@heroicons/react/24/outline");
const SchedulerTools = ({ onClose }) => {
    const bookingTools = [
        {
            icon: (0, jsx_runtime_1.jsx)(outline_1.CalendarDaysIcon, { className: 'icon-20px' }),
            label: labels_1.default.SCHEDULER_AVAILABILITY_LABEL,
            link: `${SUMO1_APPLICATION_ORIGIN}/availability`,
        },
        {
            icon: (0, jsx_runtime_1.jsx)(outline_1.Square2StackIcon, { className: 'icon-20px' }),
            label: labels_1.default.SCHEDULER_TOOLS_INTEGRATE,
            link: `${SUMO1_APPLICATION_ORIGIN}/integrations`,
        },
        {
            icon: (0, jsx_runtime_1.jsx)(outline_1.Squares2X2Icon, { className: 'icon-20px' }),
            label: labels_1.default.SCHEDULER_TOOLS_BOOKING_PAGES,
            link: `${SUMO1_APPLICATION_ORIGIN}/meeting-types`,
        },
    ];
    return ((0, jsx_runtime_1.jsx)("div", { className: 'flex flex-column gap-10px p-4px w-320px', children: bookingTools.map((tool) => ((0, jsx_runtime_1.jsxs)("a", { className: 'flex-left-center h-40px px-12px border-radius-4px text-blue-100 hover-bg-blue-4 hover-text-blue-dark no-underline cursor-pointer', href: tool.link, target: '_blank', onClick: onClose, children: [(0, jsx_runtime_1.jsxs)("div", { className: 'flex-center gap-12px text-gray-100', children: [tool.icon, (0, jsx_runtime_1.jsx)("div", { className: 'text-label-s-med', children: tool.label })] }), (0, jsx_runtime_1.jsx)(outline_1.ArrowTopRightOnSquareIcon, { className: 'icon-20px ml-auto' })] }, tool.link))) }));
};
exports.SchedulerTools = SchedulerTools;
